// extracted by mini-css-extract-plugin
export var sectionWrapper = "index-module--section-wrapper--ZFrA4";
export var tariffsSliderWrapper = "index-module--tariffs-slider-wrapper--ZA1PF";
export var tariffsWrapper = "index-module--tariffs-wrapper--wmqMD";